export default {
  title: {
    id: 'invoices_page_goodwill_gesture_tab_title',
    defaultMessage: 'Goodwill gestures',
  },
  description: {
    id: 'invoices_page_goodwill_gesture_tab_description',
    defaultMessage:
      "Goodwill gestures include credit requests and partial refunds (refunds below -X% outside of buyser's remorse policy).",
  },
  paginationCount: {
    id: 'invoices_page_goodwill_gesture_tab_pagination_count',
    defaultMessage: '{start} - {end} out of {count} items',
  },
  goodwillNumber: {
    id: 'invoices_page_goodwill_gesture_tab_table_header_invoice_number',
    defaultMessage: 'Gesture number',
  },
  orderNumber: {
    id: 'invoices_page_goodwill_gesture_tab_table_header_sales_revenues',
    defaultMessage: 'Order number',
  },
  amount: {
    id: 'invoices_page_goodwill_gesture_tab_table_header_amount_received',
    defaultMessage: 'Amount (tax incl.)',
  },
  reason: {
    id: 'invoices_page_goodwill_gesture_tab_table_header_currency',
    defaultMessage: 'Reason',
  },
  creationDate: {
    id: 'invoices_page_goodwill_gesture_tab_table_creation_date',
    defaultMessage: 'Date',
  },
  status: {
    id: 'invoices_page_goodwill_gesture_tab_table_end_date',
    defaultMessage: 'Status',
  },
  noDataSurtitle: {
    id: 'invoices_page_goodwill_gesture_tab_no_data_surtitle',
    defaultMessage: 'Nice one.',
  },
  noDataTitle: {
    id: 'invoices_page_goodwill_gesture_tab_no_data_title',
    defaultMessage: 'You haven’t made any goodwill gestures.',
  },
  noDataDescription: {
    id: 'invoices_page_goodwill_gesture_tab_no_data_description',
    defaultMessage:
      'This means your customers are most likely satisfied with their orders and experience because you haven’t had to make anything up to them.',
  },
}
